import React from "react";
import { useParams } from "react-router-dom";
import CustomBreadcrumbs, { BreadcrumbItem } from "../../../component/CustomBreadcrumbs";
import { Box } from "@mui/material";
import ProjectEditForm from "./ProjectEditForm";
import { Edit } from "react-admin";

const ProjectEdit = () => {

    const { projectId } = useParams();
    const breadcrumbItems: BreadcrumbItem[] = [
        {
            label: "Projects",
            resource: "project",
            type: "list",
        },
        {
            label: "Project",
            resource: "project",
            type: "show",
            id: projectId,
        },
        {
            label: "Edit",
            isCurrent: true,
        },
    ];

    return (
        <Edit actions={false}
                    component="div"
                    mutationMode="pessimistic"
                    title="Project Management"
                    resource="project"
                    id={projectId}
                    redirect="show"
        >
            <Box>
                <CustomBreadcrumbs title="Edit" items={breadcrumbItems} />
                <ProjectEditForm type="edit" />
            </Box>
        </Edit>
    );
}

export default ProjectEdit;
